import { Create, SimpleForm, useNotify, useRedirect } from "react-admin";

import dataProvider from "server/dataProvider";
import BackButtonToolbar from "features/BackButtonToolbar";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { studentRequests } from "api/studentApi";
import { useNotifyError } from "utils/useNotifyError";
import PreparatoryScheduleForm from "./PreparatoryScheduleForm";

const CreatePreparatorySchedule = () => {
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notifyError = useNotifyError();
  const notify = useNotify();
  const redirect = useRedirect();

  const handleSave = async values => {
    try {
      await dataProvider.customRequest(studentRequests.createPreparatorySchedule(), values, "POST");
      notify("Записът е създаден", { type: "success" });
      redirect(-1);
    } catch (err) {
      notifyError(err);

      // Room/professor double-bookings come back as a list of Bulgarian messages in `properties`.
      handleConflictError(err);
    }
  };

  return (
    <>
      <Create
        title="Създаване на разписание за подготвителна година"
        actions={<BackButtonToolbar />}
      >
        <SimpleForm onSubmit={handleSave}>
          <PreparatoryScheduleForm />
        </SimpleForm>
      </Create>
      <ConflictErrorDialog />
    </>
  );
};

export default CreatePreparatorySchedule;
